/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentTraceSpan {
    getFixupPrototypeFunction() { return AIAgentTraceSpan.fixupPrototype; }

    static newInstance(model: Partial<AIAgentTraceSpan>): AIAgentTraceSpan {
        let obj = Object.assign(new AIAgentTraceSpan(), model);
        AIAgentTraceSpan.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentTraceSpan>): AIAgentTraceSpan {
        if (!model) return null;
        return AIAgentTraceSpan.newInstance(<AIAgentTraceSpan> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentTraceSpan) {
        if (!obj) return;

        models.AIAgentTraceSpan.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentTraceSpan): boolean {
        Object.setPrototypeOf(obj, AIAgentTraceSpan.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.duration_ms === undefined) {
            this.duration_ms = 0;
        }
        if (this.input_tokens === undefined) {
            this.input_tokens = 0;
        }
        if (this.output_tokens === undefined) {
            this.output_tokens = 0;
        }
        if (this.total_tokens === undefined) {
            this.total_tokens = 0;
        }
        if (this.input_cost === undefined) {
            this.input_cost = 0;
        }
        if (this.output_cost === undefined) {
            this.output_cost = 0;
        }
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (typeof this.end_time === "string") {
            this.end_time = new Date(<string><any>this.end_time);
        }
        if (this.attributes) {
            for (let val of this.attributes) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Trace ID
     */
    trace_id: string;

    /**
     * Span ID
     */
    span_id: string;

    /**
     * Parent span ID
     */
    parent_span_id: string;

    /**
     * Span name
     */
    name: string;

    /**
     * OTEL span kind
     */
    kind: string;

    /**
     * Span start time (ISO-8601)
     */
    start_time: Date;

    /**
     * Span end time (ISO-8601)
     */
    end_time: Date;

    /**
     * Span duration / latency in milliseconds
     */
    duration_ms: number;

    /**
     * Span status code
     */
    status_code: string;

    /**
     * Span status message
     */
    status_message: string;

    /**
     * Input token count
     */
    input_tokens: number;

    /**
     * Output token count
     */
    output_tokens: number;

    /**
     * Total token count
     */
    total_tokens: number;

    /**
     * Input cost, priced from the region's published unit rates
     */
    input_cost: number;

    /**
     * Output cost, priced from the region's published unit rates
     */
    output_cost: number;

    /**
     * Span attribute key/value pairs (e.g. 'gen_ai.request.model', 'session.id', 'aws.genai.span_kind')
     */
    attributes: Array<models.KeyValuePair>;

}
